import { useMemo, useRef } from 'react';
import { useIsComponentCropped } from '@cyberint/common-utils';
import { Themes } from '../style/theme-consts';

const detectParentTheme = element => {
  let current = element;
  while (current && current !== document.body) {
    if (current.classList.contains(Themes.LIGHT)) return Themes.LIGHT;
    if (current.classList.contains(Themes.DARK)) return Themes.DARK;
    current = current.parentElement;
  }
  return null;
};

const useDetectParentTheme = ref => {
  const elementRef = useRef(null);
  const element = (ref || elementRef).current;
  const theme = useMemo(() => detectParentTheme(element), [element]);

  return { theme, elementRef: ref || elementRef };
};

export const DomUtils = {
  useIsComponentCropped,
  detectParentTheme,
  useDetectParentTheme
};
